import { render, staticRenderFns } from "./SetComponent.vue?vue&type=template&id=3a249754&"
import script from "./SetComponent.vue?vue&type=script&lang=js&"
export * from "./SetComponent.vue?vue&type=script&lang=js&"
import style0 from "./SetComponent.vue?vue&type=style&index=0&id=3a249754&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports